module.exports = __webpack_public_path__ + "static/media/logo-text-descriptive.daf74487.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo-text-descriptive.svg
// module id = 537
// module chunks = 0